import React from 'react'
import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import { ModalBody, Form, FormGroup, Label, Input } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import isEnterPressed from '@/utils/isEnterPressed'
import { Button } from '@/components/button'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { localized } from '@/decorators/localized'

const cookieName = 'bsrs_two_factor_code'

const extractCodeFromCookie = (cookie) => {
  const regex = new RegExp(`${cookieName}=(\\d+)`)
  if (regex.test(cookie)) {
    const result = regex.exec(cookie)
    if (result.length > 1) { return result[1] }
  }
  return '---'
}
@localized()
class TwoFactorAuthenticationDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      code: '',
      loading: false,
      showInvalidCode: false,
      usePreferredProviderOnly: true,
      sendingCode: false,
      showCodeWasSent: false
    }
  }
  onTwoFactorCodeChange = (e) => {
    this.setState({ code: e.target.value })
  }
  handleKeyDown = (e) => {
    if (isEnterPressed(e)) {
      e.preventDefault()
      this.onAction()
    }
  }
  resendCode = (e) => {
    e.preventDefault()
    this.setState({ usePreferredProviderOnly: false, sendingCode: true }, () => this.generateTokens())
  }
  generateTokens = () => {
    this.setState({ loading: true, showInvalidCode: false, code: '' }, () => {
      context.api.auth.generateTwoFactorTokensForCurrentUser(this.state.usePreferredProviderOnly, allowErrorDialog)
        .then(is2FARequired => {
          this.setState({ loading: false, codeWasSent: true, sendingCode: false }, () => {
            if (is2FARequired) { setTimeout(() => this.setState({ codeWasSent: false }), 2000) }
          })
          if (!is2FARequired) { this.props.onAction() }
        })
        .catch(() => this.setState({ loading: false, sendingCode: false }))
    })
  }
  onAction = () => {
    const twoFactorCookie = `${cookieName}=${this.state.code}`

    this.setState({ loading: true, showInvalidCode: false, code: '' }, () => {
      document.cookie = twoFactorCookie
      // trying to solve occasional missing two factor cookie problem - just reading it back seems to help
      if (document.cookie.indexOf(twoFactorCookie) > -1) { document.cookie = twoFactorCookie }

      context.api.auth.isTwoFactorTokenValid(this.state.usePreferredProviderOnly, allowErrorDialog)
        .then(isOk => {
          this.setState({ loading: false, showInvalidCode: !isOk })
          if (isOk) { this.props.onAction() }
        })
        .catch(() => this.setState({ loading: false }))
    })
  }
  render () {
    const { localize } = this.props
    const { loading } = this.state
    return (
      <ValidationBoundary>
        <BasicHeader title='Security:TwoFactorAuthenticationRequired' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label>{localize('Security.TwoFactorCode')}</Label>
                <Validator name='code' value={this.state.code} required>
                  <Input id='code' onKeyDown={this.handleKeyDown} onChange={this.onTwoFactorCodeChange} value={this.state.code} placeholder={localize('Security.TwoFactorCode')} autoFocus />
                </Validator>
                {this.state.showInvalidCode && <div className='errors'><ul><li>{`${localize('Security.InvalidTwoFactorCode')} (${extractCodeFromCookie(document.cookie)})`}</li></ul></div>}
              </FormGroup>
              <FormGroup>
                <Button disabled={loading} color='primary' onClick={this.resendCode}>{localize('Security.ResendCode')}</Button>
                {this.state.codeWasSent && <Label style={{ marginLeft: '10px' }}>{localize('Security.CodeWasSent')}</Label>}
                {this.state.sendingCode && <Label style={{ marginLeft: '10px' }}>{localize('Security.CodeIsBeingSent')}</Label>}
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Security.Validate' icon={loading ? 'loader bx-spin' : 'log-in'} {...this.props} onAction={this.onAction} disabled={loading || !isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: TwoFactorAuthenticationDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/twoFactorAuthentication/index.js